export const collectStrings = (name, type, data, memberNumber) => {
  if (type === "TEAM_LEADER") {
    if (name === "TEAM_NAME") {
      return {
        type: "TEAM_LEADER_TEAM_NAME",
        payload: data
      }
    } else if (name === "EMAIL_ADDRESS") {
      return {
        type: "TEAM_LEADER_EMAIL_ADDRESS",
        payload: data
      }
    } else if (name === "ORGANISATION") {
      return {
        type: "TEAM_LEADER_ORGANISATION",
        payload: data
      }
    }
  } else {
    if (name === "EMAIL_ADDRESS") {
      return {
        type: `TEAM_MEMBER_${memberNumber}_EMAIL_ADDRESS`,
        payload: data,
        index: memberNumber
      }
    }
  }
}
